// ServicesComponent.jsx — carte prestataire (design system Spotfli)
import React, { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
import styles from './ServicesComponent.module.css';

const ServicesComponent = (props) => {
  const { t } = useTranslation();
  const [imageUrl, setImageUrl] = useState('');
  const [imageError, setImageError] = useState(false);


  // Function to get proper image URL
  const getImageUrl = (images) => {
    if (!images || images.length === 0) return null;

    const imageData = images[0];

    // If imageData is a plain string URL
    if (typeof imageData === 'string') {
      return imageData;
    }

    // if (imageData.url) {
    //   return imageData.url;
    // }

    if (imageData.path) {
      return imageData.path;
    }

    if (imageData.filename) {
      return imageData.filename;
    }

    return null;
  };

  useEffect(() => {
    if (props.images && props.images.length > 0) {
      const url = getImageUrl(props.images);
      if (url) {
        setImageUrl(url);
      } else {
        setImageError(true);
      }
    } else {
      setImageError(true);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [props.images]);

  const handleImageError = () => {
    setImageError(true);
  };

  const formatPrice = (fee) => {
    const num = Number(fee);
    if (isNaN(num)) return fee;
    return num.toLocaleString('en-US');
  };

  return (
    <div className={styles.serviceCard}>
      <div className={styles.imageContainer}>
        {imageUrl && !imageError ? (
          <img
            src={imageUrl}
            alt={props.name}
            className={styles.serviceImage}
            onError={handleImageError}
            crossOrigin="anonymous"
          />
        ) : (
          <div className={styles.placeholder}>
            <i className="fa fa-image" aria-hidden="true"></i>
          </div>
        )}

        {/* Status chip */}
        <span
          className={`${styles.statusChip} ${props.isProviderActive ? styles.statusActive : styles.statusInactive}`}
          title={props.isProviderActive
            ? t('services_page.provider_active')
            : t('services_page.provider_inactive')}
        >
          <span className={styles.statusDot} />
          {props.isProviderActive
            ? t('services_page.available')
            : t('services_page.provider_inactive')}
        </span>

        {/* Category badge */}
        {props.category && (
          <span className={styles.categoryBadge}>
            {props.category}
          </span>
        )}
      </div>

      <div className={styles.content}>
        <h3 className={styles.title}>{props.name}</h3>

        {props.description && (
          <p className={styles.description}>{props.description}</p>
        )}

        <div className={styles.metaRow}>
          {props.location && (
            <span className={styles.location}>
              <i className="fa fa-map-marker" aria-hidden="true"></i>
              {props.location}
            </span>
          )}
          <span className={styles.rating}>
            <i className="fa fa-star" aria-hidden="true"></i>
            {t('services_page.not_rated')}
          </span>
        </div>

        {props.fee && (
          <div className={styles.price}>
            <span className={styles.priceAmount}>XAF {formatPrice(props.fee)}</span>
            <span className={styles.pricePer}>
              {!props.priceUnit ? (t('services_page.per_day') || '/ day') :
               props.priceUnit === 'hour' || props.priceUnit === 'per_hour' ? (t('services_page.per_hour') || '/ hr') :
               props.priceUnit === 'service' || props.priceUnit === 'per_service' ? (t('services_page.per_service') || '/ service') :
               props.priceUnit === 'fixed' ? (t('services_page.fixed') || 'fixed') :
               props.priceUnit === 'month' || props.priceUnit === 'per_month' ? (t('services_page.per_month') || '/ month') :
               props.priceUnit === 'year' || props.priceUnit === 'per_year' ? (t('services_page.per_year') || '/ year') :
               props.priceUnit === 'item' || props.priceUnit === 'per_item' ? (t('services_page.per_item') || '/ item') :
               props.priceUnit === 'day' || props.priceUnit === 'per_day' ? (t('services_page.per_day') || '/ day') :
               (props.priceUnit.startsWith('/') ? props.priceUnit : `/ ${props.priceUnit}`)}
            </span>
          </div>
        )}

        <div className={styles.buttonContainer}>
          <Link to={`/singleprovider/${props.serviceId}`} className={styles.viewButton}>
            <span>{t('services_page.view_offer')}</span>
            <i className="fa fa-arrow-right" aria-hidden="true"></i>
          </Link>
        </div>
      </div>
    </div>
  );
}

export default ServicesComponent;